import { 
    bwThemeboy, bwThemegirl, eduBlack, expBlack, contactsBlack
} from './images'

export const greenThemeDark = {
    type: 'dark',
    primary: 'rgb(245, 245, 220)',
    primary400: 'rgb(158, 224, 157)',
    primary600: '#f9f9f9',
    primary80: '#9b9b9bcc',
    primary50: '#9b9b9bb3',
    primary30: '#2c2c2cd4',
    secondary: '#181818ff',
    secondary70: '#040404b3',
    secondary50: '#04040480',
    tertiary: '#eeeeeeff',
    tertiary80: '#f9f9f9cc',
    tertiary70: '#f9f9f9b3',
    tertiary50: '#f9f9f980',
    aboutimg1: bwThemeboy,
    aboutimg2: bwThemegirl,
    eduimg: eduBlack,
    expimg: expBlack,
    contactsimg: contactsBlack
}

